{
  "Payment": "Payment",
  "SalesDocument": "Sales Document",
  "SalesDocumentLine": "Sales Document Line",
  "FiscalNetLog": "FiscalNet Log",
  "PatientMedicalService": "Provided Medical Service",
  "snapshotFields": {
    "salesDocument": "Sales Document",
    "patient": "Patient",
    "company": "Company",
    "employee": "Employee",
    "location": "Location",
    "paymentMethod": "Payment Method",
    "amount": "Amount",
    "cashAmount": "Cash Amount",
    "cardAmount": "Card Amount",
    "currency": "Currency",
    "paymentDate": "Payment Date",
    "referenceNumber": "Reference Number",
    "fiscalReceiptNumber": "Fiscal Receipt Number",
    "fiscalReceiptInfo": "Fiscal Receipt Info",
    "status": "Status",
    "notes": "Notes",
    "parentDocument": "Parent Document",
    "documentSeries": "Document Series",
    "series": "Series",
    "type": "Type",
    "typeCode": "Type Code",
    "typeName": "Type Name",
    "documentNumber": "Document Number",
    "documentDate": "Document Date",
    "dueDate": "Due Date",
    "totalAmount": "Total Amount",
    "totalAmountWithoutVat": "Total Amount without VAT",
    "totalVatAmount": "Total VAT Amount",
    "paidAmount": "Paid Amount",
    "payerDetails": "Payer Details",
    "cancellation": "Cancellation",
    "cancelledAt": "Cancelled At",
    "cancelledBy": "Cancelled By",
    "reason": "Reason",
    "convertedFromProforma": "Converted from Proforma",
    "convertedFromProformaNumber": "Converted from Proforma No.",
    "convertedToInvoice": "Converted to Invoice",
    "convertedToInvoiceNumber": "Converted to Invoice No.",
    "convertedAt": "Converted At",
    "patientMedicalService": "Provided Medical Service",
    "medicalService": "Medical Service",
    "code": "Code",
    "quantity": "Quantity",
    "unitPrice": "Unit Price",
    "discountPercentage": "Discount (%)",
    "discountAmount": "Discount Amount",
    "totalPriceWithoutVat": "Total Price without VAT",
    "totalPrice": "Total Price",
    "vat": "VAT",
    "vatPercentage": "VAT (%)",
    "vatAmount": "VAT Amount",
    "lineOrder": "Line Order",
    "correlation": "Correlation ID",
    "direction": "Direction",
    "httpStatusCode": "HTTP Status Code",
    "payload": "Payload",
    "fiscalCommands": "Fiscal Commands",
    "errorMessage": "Error Message",
    "errorDetails": "Error Details",
    "durationMs": "Duration (ms)",
    "receiptNumber": "Receipt Number",
    "payment": "Payment",
    "initiatedBy": "Initiated By",
    "deviceIdentifier": "Device Identifier",
    "fiscalNetUrl": "FiscalNet URL",
    "priceList": "Price List",
    "appointment": "Appointment",
    "patientSheet": "Patient Sheet",
    "executionDate": "Execution Date",
    "value": "Value",
    "adjustmentAmount": "Adjustment Amount",
    "valueBeforeDiscount": "Value before Discount",
    "discountedPercentage": "Discount (%)",
    "appointmentClosure": "Appointment Closure",
    "billingStatus": "Billing Status",
    "linkedSalesDocuments": "Linked Sales Documents",
    "adjustment": "Adjustment",
    "closedAt": "Closed At",
    "fullName": "Full Name",
    "idCardSeries": "ID Card Series",
    "idCardNumber": "ID Card Number",
    "county": "County",
    "locality": "Locality",
    "companyName": "Company Name",
    "vatNumber": "VAT Number",
    "registrationNumber": "Registration Number",
    "iban": "IBAN",
    "bankName": "Bank Name",
    "contactPerson": "Contact Person",
    "payerCompany": "Payer Company",
    "categoryName": "Category"
  }
}
